var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{staticClass:"hero",attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/hydro-ottawa-ai.appspot.com/o/robot-story.mp4?alt=media&token=d5f5c160-f3d5-46cb-993d-64fa6719fe97","autoplay":"","muted":"","loop":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }